export const MAX_POSITIONS = 80
export const MAX_POSITION_LENGTH = 80

/** Configured labels, plus the current value when it is not already in the list. */
export function positionChoices(configured: string[], current: string): string[] {
  const list = configured.map((item) => String(item || '').trim()).filter(Boolean)
  const cur = String(current || '').trim()
  if (cur && !list.includes(cur)) return [cur, ...list]
  return list
}
